module.exports = __webpack_public_path__ + "static/media/family-m-3.ab55e85d.png";